import React from "react";
import { Route, Routes } from "react-router-dom";
import UserProfile from "./Components/UserProfile/UserProfile";
//import UserExperiment from "./Components/Experiments/UserExperiment";
//import AdminProfile from "./Components/Admin/AdminProfile";
import NotFound from "./Components/NotFound";
//import TestFiles from "../TestFiles";
import LoginRegister from "./Components/LoginRegister/LoginRegister";
import WelcomePage from "./Components/WelcomePage/WelcomePage";
import RequireUser from "./Components/lib/RequireUser";
import AdminInformation from "./Components/Admin/AdminInformation";
import ExperimentProjectSelect from "./Components/Experiments/ExperimentProjectSelect";
import MyLabSelect from "./Components/MyLab/MyLabSelect";
import MyLabProjects from "./Components/MyLab/MyLabProjects";
import MyLabSubgroups from "./Components/MyLab/MyLabSubgroups";
import UserExperiment from "./Components/Experiments/UserExperiment";
import { title } from "process";
import AdminGroupSelect from "./Components/Admin/AdminGroupSelect";
import ProjectSelect from "./Components/Projects/ProjectSelect";
import SubgroupSelect from "./Components/Subgroups/SubgroupSelect";
import AllGroups from "./Components/Groups/AllGroups";
import SharedDataExperiment from "./Components/SharedData/SharedDataExperiment";
import SharedDataProjectSelect from "./Components/SharedData/SharedDataProjectSelect";

function App() {
  return (
    <Routes>
      <Route path="/" element={<LoginRegister />} />
      <Route path="WelcomePage" element={<WelcomePage />} />

      <Route
        path="ExperimentProjectSelect"
        element={<ExperimentProjectSelect />}
      />
      <Route path="AdminGroupSelect" element={<AdminGroupSelect />} />
      <Route path="MyLabSelect" element={<MyLabSelect />} />
      <Route path="MyLabProjects" element={<MyLabProjects />} />
      <Route path="MyLabSubgroups" element={<MyLabSubgroups />} />
      <Route path="ProjectSelect" element={<ProjectSelect />} />
      <Route path="SubgroupSelect" element={<SubgroupSelect />} />
      <Route path="AdminInformation" element={<AdminInformation />} />
      <Route path="UserProfile" element={<UserProfile />} />
      <Route path="UserExperiment" element={<UserExperiment />} />
      <Route path="AllGroups" element={<AllGroups />} />
      <Route path="SharedDataExperiment" element={<SharedDataExperiment />} />
      <Route
        path="SharedDataProjectSelect"
        element={<SharedDataProjectSelect />}
      />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default App;

// <Route path="UserExperiment" element={<UserExperiment title={""} />} />
//      <Route path="UserExperiment" element={<UserExperiment />} />
